import { memo } from 'react';
import SkeletonView from 'conversations-skeleton-state/components/SkeletonView';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function TimelineCallMetadataSkeleton() {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(SkeletonView, {
      blockSize: "14px",
      inlineSize: "228px",
      marginBlockEnd: "400"
    }), /*#__PURE__*/_jsx(SkeletonView, {
      blockSize: "14px",
      inlineSize: "100%",
      marginBlockEnd: "200"
    }), /*#__PURE__*/_jsx(SkeletonView, {
      blockSize: "14px",
      inlineSize: "80%",
      marginBlockEnd: "200"
    })]
  });
}
export default /*#__PURE__*/memo(TimelineCallMetadataSkeleton);